var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-layout',{staticClass:"goods",attrs:{"title":"推广通日常数据","refresh":_vm.refresh,"back":_vm.back,"showBack":true}},[_c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }